module.exports = __webpack_public_path__ + "img/ball_4.b780ff2b.png";